import React, { useState, } from "react";
import { Button, } from "reactstrap";
import { compose, withHandlers } from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  required,
  SubmitButton,
  LoadingMsg,
} from "components/common";
import ImportModal from "components/ImportModal";
import { ReportContainerTrialB } from "./components";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";
import { Trans } from "react-i18next";
import { humanError } from "services/util";
import { createPortal } from "react-dom";
import { useOrganisationContext } from "hooks/useOrganisationContext";


export const TrialBalanceWithMovementView = ({ data, item, handleSubmit, setState, client, t }) => {

  const { selectedOrganisation } = useOrganisationContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleUploadFile = async (selectedFile) => {

    const formData = new FormData();
    setIsLoading(true)
    formData.append('file', selectedFile)

    client.post(`reports/${selectedOrganisation.id}/upload-ledger`, formData)
      .then((response) => {
        setIsLoading(false)
        NotificationManager.success(t("File imported successfully"));
        setTimeout(() => {
          setIsModalOpen(false);
        }, 800);
      })
      .catch((err) => {

        setIsLoading(false);

        const error_message = humanError(err, "Error while importing File", t)
        NotificationManager.error(error_message);
      });
  }

  const immportantNotes = [
    'Go to Xero.',
    'In the Accounting menu, select Reports.',
    'Find and open the General Ledger Detail report. You can use the search field in the top right corner.',
    'Under Date range, select a start and end date',
    "Under Grouping/Summarising, choose 'Account Code & Name'.",
    'Click Update to run the report.',
    'Click Export, then click Excel.',
  ]

  return (
    <Page>
      {isLoading &&
        createPortal(
          <div className="content">
            <div className="loader"></div>
            {<LoadingMsg />}
          </div>, document.querySelector('#loader-holder')
        )}

      <div className="disc">
        <h4><Trans>Trail Balance with movement (Using General Ledger Detail report)</Trans></h4>
        <p className="text-muted"><Trans>This report is based on <strong><a target="_blank" href="https://reporting.xero.com/Reports/v1/Run/1071" className="link btn-link">General Ledger Detail report</a></strong> export from Xero, please follow the instructions on the import modal</Trans></p>
      </div>
      <LocalForm
        className="d-print-none"
        getDispatch={(dispatch) => setState({ dispatch })}
        onSubmit={handleSubmit}
        initialState={item}
        validators={{
          to_date: { required },
        }}
      >
        <div className="d-flex align-items-center">
          <FormGroup label="From Date" className="mr-3">
            <DatePicker model=".from_date" className="form-control" />
          </FormGroup>
          <FormGroup label="To Date" className="mr-3">
            <DatePicker model=".to_date" className="form-control" />
          </FormGroup>
          {/* <FormGroup label="&nbsp;" className="mr-3">
            <FormGroup label="Cash transactions only" check>
              <Control.checkbox model=".payments_only" />
            </FormGroup>
          </FormGroup> */}
          <FormGroup label="&nbsp;">
            <SubmitButton size="sm" className="d-block">
              Update
            </SubmitButton>
          </FormGroup>
          <FormGroup label="&nbsp;" className="mr-3">
            <Button size="sm" color="primary" onClick={openModal}>
              <Trans>Import</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
            </Button>
          </FormGroup>

          <ImportModal
            isOpen={isModalOpen}
            toggle={closeModal}
            title="General Ledger"
            importantNotes={immportantNotes}
            handleUpload={handleUploadFile}
            showTemplate={false}
          />
        </div>
      </LocalForm>
      {data && <ReportContainerTrialB report={data} />}
    </Page>
  )
};

const loadReport = (item, client, id) =>
  client
    .post(`xero_actions/${id}/trial_balance_with_movement`, item)
    .get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    to_date: moment().format("YYYY-MM-DD"),
    from_date: moment().startOf('month').format("YYYY-MM-DD"),
    payments_only: false
  })),
  onMount(({ client, item, selectedOrganisation }) => () => {
    const { id } = selectedOrganisation;

    item.payments_only = ['true', true, '1', 1].includes(item.payments_only) || false;

    return Promise.props({
      data: null,
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, client, dispatch, setReportParams, selectedOrganisation }) =>
        (item) => {
          setReportParams(item);
          return loadReport(item, client, selectedOrganisation.id)
            .then((data) => setState({ data }))
            .finally(() => dispatch(actions.setSubmitted("local", true)));
        },
  })
);

export const TrialBalanceWithMovement = enhance(TrialBalanceWithMovementView)
